import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../Services/apiService";
import ExpectedObjectivesForStagea from "../../PagesReportStage/ExpectedObjectivesForStagea";
import InformationSocialMediaPage from "../../PagesReportStage/InformationSocialMediaPage";
import InformationWebsitePage from "../../PagesReportStage/InformationWebsitePage";
import InformationAppPage from "../../PagesReportStage/InformationAppPage";
import LessonsLearnedPage from "../../PagesReportStage/LessonsLearnedPage";
import ButtonAHSF from "../../Components/ButtonAHSF";
import OpportunitiesObtained from "../../PagesReportStage/OpportunitiesObtained";
import ChallengesEncountered from "../../PagesReportStage/ChallengesEncounteredThatAffected";
import EventsActivities from "../../PagesReportStage/EventsActivities";
import EventsActivitiesNextFlow from "../../PagesReportStage/EventsActivitiesNextFlow";
import SuccessStory from "../../PagesReportStage/SuccessStory";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";
import JobOpportunitiesDuringProject from "../../PagesReportStage/JobOpportunitiesDuringProject";
import FinancialSummary from "../../PagesReportStage/FinancialSummary";
import RS_AdminStrativeStage from "../../PagesReportStage/RS_AdminStrativeStage";
import RS_DirectCost from "../../PagesReportStage/RS_DirectCost";

import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report";
import { WorkFlowReport } from "../../Redux/Reducers/ReportStage/WorkFlowReport";
import TechnicalReportNotes from "../../PagesReportStage/TechnicalReportNotes";
import { GetSpecificRowNoteInformationWebsite } from "../../Redux/Reducers/ReportStage/InformationWebsite";
import { GetSpecificRowNoteLessonsLearned } from "../../Redux/Reducers/ReportStage/LessonsLearned";
import { GetSpecificRowNoteEventsActivities } from "../../Redux/Reducers/ReportStage/EventsActivities";
import { GetSpecificRowNoteEventsActivitiesNextFlow } from "../../Redux/Reducers/ReportStage/EventsActivitiesNextFlow";
import { GetSpecificRowNoteInformationApp } from "../../Redux/Reducers/ReportStage/InformationApp";
import JobOpportunitiesSummary from "../../PagesReportStage/JobOpportunitiesDuringProject/JobOpportunitiesSummary";
import { GetSpecificRowNoteInformationSocialMedia } from "../../Redux/Reducers/ReportStage/InformationSocialMedia";
import { GetSpecificRowNoteSuccessStory } from "../../Redux/Reducers/ReportStage/SuccessStory";
import { GetSpecificRowNoteOpportunitiesObtained } from "../../Redux/Reducers/ReportStage/OpportunitiesObtained";
import { GetSpecificRowNoteJobOpportunitiesDuringProject } from "../../Redux/Reducers/ReportStage/JobOpportunitiesDuringProject";
import { GetSpecificRowNoteExpectedObjectivesForStage } from "../../Redux/Reducers/ReportStage/ExpectedObjectivesForStag";
import { GetSpecificRowNoteForChallengesEncounteredThatAffected } from "../../Redux/Reducers/ReportStage/ChallengesEncounteredThatAffected";
import InformationAboutApplication from "../../PagesReportStage/InformationAboutApplication";
import Swal from "sweetalert2";
import PopupAHSF from "../../Components/PopupAHSF";
import StageInformation from "../../PagesReportStage/SatageInformation";

import $ from "jquery";
import { GetTechnicalReportsRequiredByReportGuidAndName } from "../../Redux/Reducers/ReportStage/TechnicalReportsRequired";
const ReportStageContainer = (props) => {
  const [nameActionManager, setNameActionManager] = useState("");
  const [ShowActionManager, setShowActionManager] = useState("");
  const [ActionFlowGuid, setActionFlowGuid] = useState("");
  const [showActionReturnEditManager, setshowActionReturnEditManager] =
    useState(false);
  const [GuidActionReturnEditManager, setGuidActionReturnEditManager] =
    useState(false);
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);

  // State to prevent multiple form submissions
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  let { stageGuid } = useParams();
  const [canEdit, setCanEdit] = useState(false);
  const [show, setshow] = useState(false);
  // فك تشفير ال  param
  console.log(props.location, "sdsdwdASdad");
  const [dataJsonObject, SetDataJsonObject] = useState();
  const navigat = useNavigate(); // Hook to navigate between routes

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //   let fieldsName = props.fieldsName;
    //   let code = jsonData[fieldsName];
    //   SetDataJsonObject(code);

    //console.log(jsonData, "jsonData");
  };

  useEffect(() => {
    dataJson();
  }, []);
  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
      loadingReportsStagesById:
        state.TypeOfJobOpportunityDropDown.loadingReportsStagesById,
      ReportsStagesById: state.Stages.ReportsStagesById,
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      reports: state.ReportByAppGuidReducers.ReportByApp,
      OneSpecificRowNoteInformationWebsite:
        state.InformationWebsite?.OneSpecificRowNoteInformationWebsite,
      OneSpecificRowNoteLessonsLearned:
        state.LessonsLearned?.OneSpecificRowNoteLessonsLearned,
      OneSpecificRowNoteEventsActivities:
        state.EventsActivities?.OneSpecificRowNoteEventsActivities,
      OneSpecificRowNoteEventsActivitiesNextFlow:
        state.EventsActivitiesNextFlow
          ?.OneSpecificRowNoteEventsActivitiesNextFlow,
      OneSpecificRowNoteInformationApp:
        state.InformationApp?.OneSpecificRowNoteInformationApp,
      OneSpecificRowNoteInformationSocialMedia:
        state.InformationSocialMedia?.OneSpecificRowNoteInformationSocialMedia,
      OneSpecificRowNoteSuccessStory:
        state.SuccessStory?.OneSpecificRowNoteSuccessStory,
      OneSpecificRowNoteOpportunitiesObtained:
        state.OpportunitiesObtained?.OneSpecificRowNoteOpportunitiesObtained,
      OneSpecificRowNoteExpectedObjectivesForStage:
        state.ExpectedObjectivesForStage
          ?.OneSpecificRowNoteExpectedObjectivesForStage,
      OneSpecificRowNoteJobOpportunitiesDuringProject:
        state.JobOpportunitiesDuringProject
          ?.OneSpecificRowNoteJobOpportunitiesDuringProject,
      OneSpecificRowNoteForChallengesEncounteredThatAffected:
        state.ChallengesEncounteredThatAffected
          ?.OneSpecificRowNoteForChallengesEncounteredThatAffected,
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
    };
  });
  const kofta = useSelector(
    (state) => state.InformationWebsite?.OneSpecificRowNoteInformationWebsite
  );
  const getReportStage = async () => {
    const report = await dispatch(
      GetReportByAppGuid({
        aI_ApplicationInformationId:
          localStorage.getItem("aI_ApplicationInformationId") ||
          localStorage.getItem("aI_ApplicationInformationId_Manager"),
      })
    );
    if (report.payload) {
      const reportStage = await dispatch(GetReportStageByID(stageGuid));
      console.log(reportStage.payload, "canEdit", report.payload);

      if (reportStage.payload) {
        console.log(
          reportStage.payload?.currentStage ==
            reportStage.payload?.pR_StagesNumberId,
          reportStage.payload?.canEdit,
          window.location.href.includes("manager") == false,
          (state.reports?.pR_ReportStatusGuid,
          state.reports?.pR_ReportStatusGuid),
          "tetst"
        );

        if (
          reportStage.payload?.currentStage ==
            reportStage.payload?.pR_StagesNumberId &&
          reportStage.payload?.canEdit &&
          window.location.href.includes("manager") == false &&
          (report.payload?.pR_ReportStatusGuid ==
            "bc7d23b3-2211-46ab-8957-c953f6dc6322" ||
            report.payload?.pR_ReportStatusGuid ==
              "7411c9e6-e567-41fb-9505-d0eb08ef25dd")
        ) {
          setCanEdit(true);
          setshow(true);
        } else {
          setCanEdit(false);
          setshow(true);
        }
      }
      console.log(props.location, "ssssssssssdddw");

      if (props.location == "manager") {
        setCanEdit(false);
      }
    }
  };
  useEffect(() => {
    // dispatch(
    //   GetReportByAppGuid({
    //     aI_ApplicationInformationId:
    //     localStorage.getItem("aI_ApplicationInformationId") ||
    //     localStorage.getItem("aI_ApplicationInformationId_Manager"),
    //   })
    // );
    getReportStage();
  }, []);
  const validatePage = async () => {
    var validate = await dispatch(ValidationAllPageReports(stageGuid));
    console.log(validate);

    if (validate.payload?.length == 0) {
      dispatch(
        WorkFlowReport({
          pR_ReportActionFlowGuid: "54e0efc7-6248-42f4-9a84-9d35302ac33f",
          pR_ReportsId: state.reports?.pR_ReportsId,
          appGuid: localStorage.getItem("aI_ApplicationInformationId"),
        })
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم التقديم بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      $(".ReportStage").trigger("click");
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "يرجى تعبئة الحقول المطلوبة",
        text: "تجدها محددة باللون الاحمر",
        showConfirmButton: true,
        confirmButtonText: "خروج",
        // timer: 1500,
        // width: "500px",
      });

      // setisPopupOpenStatus(true);
    }
    // dispatch(
    //   WorkFlowReport({
    //     pR_ReportActionFlowGuid: "54e0efc7-6248-42f4-9a84-9d35302ac33f",
    //     pR_ReportsId: state.reports?.pR_ReportsId,
    //     appGuid: localStorage.getItem("aI_ApplicationInformationId"),
    //   })
    // );
  };

  useEffect(() => {
    //------------------LessonsLearned------------------------
    dispatch(
      GetSpecificRowNoteLessonsLearned({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "455265a0-6d80-41ce-9efa-cce98a4dac90",
      })
    );

    //------------------InformationWebsite------------------------

    dispatch(
      GetSpecificRowNoteInformationWebsite({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "0be3dc0f-5c01-433e-8267-bad54acac4cc",
      })
    );

    //------------------EventsActivities------------------------

    dispatch(
      GetSpecificRowNoteEventsActivities({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "d1deb814-1c8b-47df-826f-0371a6713e02",
      })
    );

    //------------------EventsActivitiesNextFlow------------------------

    dispatch(
      GetSpecificRowNoteEventsActivitiesNextFlow({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "ff368e69-c008-43a7-b417-4d803a3aa04e",
      })
    );

    //------------------InformationApp------------------------

    dispatch(
      GetSpecificRowNoteInformationApp({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "6578c3f8-9f73-4cc7-8512-58307be500e3",
      })
    );

    //------------------InformationSocialMedia------------------------

    dispatch(
      GetSpecificRowNoteInformationSocialMedia({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "3ee18600-24e9-432b-8605-a397345b4bdc",
      })
    );
    //------------------SuccessStory------------------------

    dispatch(
      GetSpecificRowNoteSuccessStory({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "a0cb27bb-8e4d-4369-b227-159f7e481f8a",
      })
    );

    //------------------OpportunitiesObtained------------------------

    dispatch(
      GetSpecificRowNoteOpportunitiesObtained({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "86f67aa4-129c-4d33-87bc-bf24dd9b2668",
      })
    );

    //------------------JobOpportunitiesDuringProject------------------------

    dispatch(
      GetSpecificRowNoteJobOpportunitiesDuringProject({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "02eb2813-a4f2-4be8-ae7d-83c45a431c7d",
      })
    );
    //------------------ExpectedObjectivesForStage------------------------

    dispatch(
      GetSpecificRowNoteExpectedObjectivesForStage({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "5abb5a13-039f-4bf4-b4c4-5d38cfce636d",
      })
    );
    //------------------ChallengesEncounteredThatAffected------------------------

    dispatch(
      GetSpecificRowNoteForChallengesEncounteredThatAffected({
        pR_ReportsStagesGuid: stageGuid,
        pR_NotesTableId: "49c8b35c-7290-4171-b6a2-d1bb0e93841d",
      })
    );
  }, []);

  console.log(
    state.ReportsStagesById?.pR_ReportsId,
    "wdwdwdwdwwwd",
    state.reports?.pR_ReportStatusGuid == "80cd0c1e-b4d3-4fbf-acd5-5627c455915b"
  );
  console.log(canEdit, "canEdit");
console.log(canEdit,"sssssdwdwdwd");

  useEffect(() => {
    setShowActionManager(false);
    //قدمت المرحلة من قبل المتقدم
    if (
      state.ReportsStagesById?.pR_StatusStagesGuid ==
        "e8520232-873a-4237-aac2-9520f3e55f24" &&
      state.RoleByUserGuid?.includes("45ab458b-7479-4b83-bf88-49a9cd65226d")
    ) {
      setActionFlowGuid("092dcc54-b2ec-4a51-adc9-ab98be95853a");
      setshowActionReturnEditManager(true);
      setGuidActionReturnEditManager("5e000312-a7a5-4dcd-a67d-9765408e7de7");
      setShowActionManager(true);
      setNameActionManager("تنفيذ الإجراء بواسطة الموظف الأول");
    }
    // بانتظار التعديل من قبل المتقدم
    else if (
      state.ReportsStagesById?.pR_StatusStagesGuid ==
      "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
    ) {
      setshowActionReturnEditManager(false);
      setShowActionManager(false);
      setNameActionManager("");
    }
    


    //الموافقة على التقرير المرحلي من قبل الموظف الاول
    else if (
      state.ReportsStagesById?.pR_StatusStagesGuid ==
        "9ff0a911-3148-4eef-bca7-88f98dc32900" &&
      state.RoleByUserGuid?.includes("f8decae8-ba89-484c-94f6-22c64996266a")
    ) {


      setActionFlowGuid("052d8767-d285-403f-89ee-860a3ff423b9");
      setshowActionReturnEditManager(true);
      setGuidActionReturnEditManager("052d8767-d285-403f-89ee-860a3ff423b9");

      setShowActionManager(true);
      setNameActionManager("تنفيذ الإجراء بواسطة الموظف الثاني");


    }
    //بانتظار التعديل من قبل الموظف الاول
    else if (
      state.ReportsStagesById?.pR_StatusStagesGuid ==
        "8a9ef244-30e5-433b-89ab-11b3c90e6907" &&
      state.RoleByUserGuid?.includes("45ab458b-7479-4b83-bf88-49a9cd65226d")
    ) {
      setActionFlowGuid("092dcc54-b2ec-4a51-adc9-ab98be95853a");
      setshowActionReturnEditManager(false);

      setNameActionManager("تنفيذ الإجراء بواسطة الموظف الأول");
      setShowActionManager(true);
    }
    //الموافقة على التقرير المرحلي من قبل الموظف الثاني
    else if (
      state.ReportsStagesById?.pR_StatusStagesGuid ==
      "f7395820-fe1c-4023-9ca4-6b38d83bd8f8"
    ) {
     setActionFlowGuid("052d8767-d285-403f-89ee-860a3ff423b9");
      setshowActionReturnEditManager(true);
      setGuidActionReturnEditManager("052d8767-d285-403f-89ee-860a3ff423b9");

      setShowActionManager(true);
      setNameActionManager("تنفيذ الإجراء بواسطة الموظف الثاني");
    }
  }, [state.ReportsStagesById?.pR_StatusStagesGuid, state.RoleByUserGuid]);
  const WorkFlowManager = (returnEdit) => {
    dispatch(
      WorkFlowReport({
        pR_ReportActionFlowGuid:
          returnEdit == "returnEdit"
            ? state.ReportsStagesById?.pR_StatusStagesGuid=="9ff0a911-3148-4eef-bca7-88f98dc32900"?"e644f86f-b114-41df-a4cf-e55b653c7750":"5e000312-a7a5-4dcd-a67d-9765408e7de7"
            : ActionFlowGuid,
        pR_ReportsId: state.ReportsStagesById?.pR_ReportsId,
        appGuid:
          localStorage.getItem("aI_ApplicationInformationId") ||
          localStorage.getItem("aI_ApplicationInformationId_Manager"),
      })
    );
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم اخذ الاجراء بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
    navigat("/grants/manager/Report"); // Hook to navigate between routes
  };

  console.log(
    state.OneSpecificRowNoteJobOpportunitiesDuringProject,
    "FGFDGFDDF",
    state.ValidateReportStage
  );

  console.log(state.ReportsStagesById?.pR_StatusStagesGuid,"Ssssssssssdwdwd");
  
  const [appList, setAppList] = useState(false);
  const [webList, setWebList] = useState(false);
  const getRequiredData = async () => {
    const app = await dispatch(
      GetTechnicalReportsRequiredByReportGuidAndName({
        reportId:
          localStorage.getItem("aI_ApplicationInformationId") ||
          localStorage.getItem("aI_ApplicationInformationId_Manager"),
        TableName: "app",
      })
    );
    if (app.payload) {
      setAppList(true);
    }

    const website = await dispatch(
      GetTechnicalReportsRequiredByReportGuidAndName({
        reportId:
          localStorage.getItem("aI_ApplicationInformationId") ||
          localStorage.getItem("aI_ApplicationInformationId_Manager"),
        TableName: "website",
      })
    );
    if (website.payload) {
      setWebList(true);
    }
  };
  useEffect(() => {
    getRequiredData();
  }, []);

  console.log(state.OneSpecificRowNoteLessonsLearned,"ssssssssssdwdwd");
  
  return (
    <>
      {!state.loadingReportsStagesById && show ? (
        <SharedDiv
          showTitle={true}
          titleName="التقرير المرحلي"
          child={[
            <>
              <SharedDiv
                showTitle={true}
                titleName="معلومات عن الطلب"
                child={[<InformationAboutApplication />]}
              />

              <SharedDiv
                showTitle={true}
                titleName=""
                child={[
                  <StageInformation
                    pR_ReportsStagesGuid={
                      props.stageGuid ? props.stageGuid : stageGuid
                    }
                  />,
                ]}
              />

              {props.location != "fromSummary" &&
              state.ReportsStagesById?.pR_StatusStagesGuid ==
                "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244" &&
              window.location.href.includes("manager") == false ? (
                <TechnicalReportNotes
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                />
              ) : (
                ""
              )}
              {props.location != "fromSummary" &&
              (state.ReportsStagesById?.pR_StatusStagesGuid ==
                "60a73fb7-7a08-4fcc-a1c0-bd0ad2796673" ||
                state.ReportsStagesById?.pR_StatusStagesGuid ==
                  "8a9ef244-30e5-433b-89ab-11b3c90e6907" ||
                state.ReportsStagesById?.pR_StatusStagesGuid ==
                  "e8520232-873a-4237-aac2-9520f3e55f24") &&
              state.RoleByUserGuid?.includes(
                "45ab458b-7479-4b83-bf88-49a9cd65226d"
              ) &&
              window.location.href.includes("manager") == true ? (
                <TechnicalReportNotes
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                />
              ) : (
                ""
              )}
              <ExpectedObjectivesForStagea
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteExpectedObjectivesForStage == null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    : state.OneSpecificRowNoteExpectedObjectivesForStage
                        ?.canEdit)
                }
                specificOrMulti={props.specificOrMulti}
                location={props.location}
                reportId={props.reportId}
              />

              {props.location == "fromSummary" ? (
                <FinancialSummary
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                  canEdit={
                    canEdit &&
                    state.OneSpecificRowNoteExpectedObjectivesForStage?.canEdit
                  }
                  specificOrMulti={props.specificOrMulti}
                  location={props.location}
                  reportId={props.reportId}
                />
              ) : (
                <></>
              )}

              {state.ValidateReportStage &&
              state.ValidateReportStage?.includes(
                "PR_StagesNumberIdMassege"
              ) ? (
                <p style={{ color: "red", marginRight: "2%" }}>
                  {dataJsonObject["PR_StagesNumberIdMassege"].nameAR}
                </p>
              ) : (
                ""
              )}

              {props.location == "fromSummary" ? (
                <JobOpportunitiesSummary
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                  canEdit={
                    canEdit &&
                    (state.OneSpecificRowNoteJobOpportunitiesDuringProject !=
                    null
                      ? state.OneSpecificRowNoteJobOpportunitiesDuringProject
                          ?.canEdit
                      : true)
                  }
                  location={props.location}
                  reportId={props.reportId}
                />
              ) : (
                ""
              )}
              {props.location != "fromSummary" ? (
                <JobOpportunitiesDuringProject
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                  canEdit={
                    canEdit &&
                    (state.OneSpecificRowNoteJobOpportunitiesDuringProject ==
                      null &&
                    state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                      ? true
                      : state.ReportsStagesById?.pR_StatusStagesGuid ==
                        "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                      ? true
                      : state.OneSpecificRowNoteJobOpportunitiesDuringProject
                          ?.canEdit)
                  }
                  location={props.location}
                  reportId={props.reportId}
                />
              ) : (
                ""
              )}
              <InformationSocialMediaPage
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteInformationSocialMedia ==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    : state.OneSpecificRowNoteInformationSocialMedia?.canEdit
                    )
                }
                location={props.location}
                reportId={props.reportId}
              />
              {webList ? (
                <InformationWebsitePage
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                  // canEdit={canEdit}
                  canEdit={
                    canEdit &&
                    (state.OneSpecificRowNoteInformationWebsite ==
                      null &&
                    state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                      ? true
                      : state.ReportsStagesById?.pR_StatusStagesGuid ==
                        "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                      ? true
                      :  state.OneSpecificRowNoteInformationWebsite?.canEdit
                      )
                  }
                  location={props.location}
                  reportId={props.reportId}
                />
              ) : (
                ""
              )}
              {appList ? (
                <InformationAppPage
                  pR_ReportsStagesGuid={
                    props.stageGuid ? props.stageGuid : stageGuid
                  }
                  canEdit={
                    canEdit &&
                    (state.OneSpecificRowNoteInformationApp ==
                      null &&
                    state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                      ? true
                      : state.ReportsStagesById?.pR_StatusStagesGuid ==
                        "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                      ? true
                      : state.OneSpecificRowNoteInformationApp?.canEdit
                     )
                  }
                  location={props.location}
                  reportId={props.reportId}
                />
              ) : (
                ""
              )}
              <OpportunitiesObtained
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteOpportunitiesObtained ==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    : state.OneSpecificRowNoteOpportunitiesObtained?.canEdit
                    )
                }
                location={props.location}
                reportId={props.reportId}
              />
              <ChallengesEncountered
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteForChallengesEncounteredThatAffected ==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    : state
                        .OneSpecificRowNoteForChallengesEncounteredThatAffected
                        ?.canEdit
                   )
                }
                location={props.location}
                reportId={props.reportId}
              />
              <EventsActivities
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteEventsActivities==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    :  state.OneSpecificRowNoteEventsActivities?.canEdit
                   )
                }
                location={props.location}
                reportId={props.reportId}
              />
              <EventsActivitiesNextFlow
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteEventsActivitiesNextFlow ==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    :  state.OneSpecificRowNoteEventsActivitiesNextFlow?.canEdit
                   )
                }
                location={props.location}
                reportId={props.reportId}
              />
              <LessonsLearnedPage
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit 
                  &&


                  (
                    state.OneSpecificRowNoteLessonsLearned ==null
                     &&
                  state.ReportsStagesById?.pR_StatusStagesGuid =="d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"?
                   true
                    : state.ReportsStagesById?.pR_StatusStagesGuid =="38ee107e-8edd-40b8-8403-a0b76e0cfaf2"?
                     true
                    :  state.OneSpecificRowNoteLessonsLearned?.canEdit
                   )
                }
                location={props.location}
                reportId={props.reportId}
              />
              <SuccessStory
                pR_ReportsStagesGuid={
                  props.stageGuid ? props.stageGuid : stageGuid
                }
                canEdit={
                  canEdit &&
                  (state.OneSpecificRowNoteSuccessStory ==
                    null &&
                  state.ReportsStagesById?.pR_StatusStagesGuid ==
                    "d1a16c37-434b-4c2d-ae3c-e1dbe16c0244"
                    ? true
                    : state.ReportsStagesById?.pR_StatusStagesGuid ==
                      "38ee107e-8edd-40b8-8403-a0b76e0cfaf2"
                    ? true
                    :  state.OneSpecificRowNoteSuccessStory?.canEdit
                   )
                }
                location={props.location}
                reportId={props.reportId}
              />
              {props.location != "fromSummary" ? (
                <>
                  <RS_AdminStrativeStage
                    canEdit={canEdit}
                    location={props.location}
                  />
                  <RS_DirectCost canEdit={canEdit} location={props.location} />
                </>
              ) : (
                ""
              )}
              {/* {canEdit && props.location != "manager" ? (
                <>
                  <RS_AdminStrativeStage />
                  <RS_DirectCost />
                </>
              ) : (
                <></>
              )} */}

              {/* {
              canEdit &&props.location!="manager"? <>
 
              <RS_AdminStrativeStage />
              <RS_DirectCost />
              </>:<></>
              } */}

              {canEdit ? (
                <div style={{ justifyItems: "center", padding: "1%" }}>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      validatePage();
                    }}
                    disabled={false}
                    title={"تقديم التقرير المرحلي"}
                    text={"تقديم التقرير المرحلي"}
                    show={true}
                  />
                </div>
              ) : (
                ""
              )}

              {props.location == "manager" && ShowActionManager ? (
                <div className="containerButton">
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      WorkFlowManager();
                    }}
                    disabled={false}
                    title={nameActionManager}
                    text={nameActionManager}
                    show={true}
                  />

                  {showActionReturnEditManager ? (
                    <ButtonAHSF
                      type={"submitter"}
                      onClick={() => {
                        WorkFlowManager("returnEdit");
                      }}
                      disabled={false}
                      title={"إرجاع التقرير المرحلي للتعديل"}
                      text={"إرجاع التقرير المرحلي للتعديل"}
                      show={true}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </>,
          ]}
        />
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingReportsStagesById} />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus} // Popup visibility state
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Function to close popup
        // forValidateAllPages={true} // Indicates the popup is for page validation
        forValidate={true}
        maxWidth="50%" // Popup width
        title="يرجى تعبئة الحقول المطلوبة" // Popup title
        componentBody={[]} // Validation errors content
      />
    </>
  );
};
export default ReportStageContainer;
